"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    CONFIG_FILE: null,
    JS_FILES: null,
    STYLE_SHEET_FILES: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CONFIG_FILE: function() {
        return CONFIG_FILE;
    },
    JS_FILES: function() {
        return JS_FILES;
    },
    STYLE_SHEET_FILES: function() {
        return STYLE_SHEET_FILES;
    }
});
const CONFIG_FILE = 'rune.config.cjs';
const STYLE_SHEET_FILES = [
    'common.css',
    'vendors.css',
    'main.css'
];
const JS_FILES = [
    'common.js',
    'main.js',
    'runtime.js',
    'vendors.js'
];
